import api from '../utils/api';

const { __ } = wp.i18n;

const providerColors = {
    openai: { bg: '#d4f5e9', text: '#0d7a4b' },
    google: { bg: '#dce8fc', text: '#1a5dc4' },
    grok: { bg: '#d9eefb', text: '#0d7bb5' },
    deepseek: { bg: '#dce0fc', text: '#2d4bc4' },
};

const providerIcons = {
    openai: '●',
    google: '●',
    grok: '●',
    deepseek: '●',
};

export default function AgentCard({
    agent,
    onEdit,
    onDelete,
    onToggle,
    onRun,
    onDuplicate,
}) {
    const isActive = agent.status === 'active';
    const colors = providerColors[agent.provider] || { bg: '#f0f0f1', text: '#666' };

    const formatRecurrence = () => {
        if (agent.recurrence_type === 'interval') {
            const interval = agent.recurrence_interval;
            const time = agent.recurrence_time || '09:00';
            if (interval === 1) {
                return __('Every day at %s', 'ai-bulk-post').replace('%s', time);
            }
            return __('Every %d days at %s', 'ai-bulk-post')
                .replace('%d', interval)
                .replace('%s', time);
        }

        if (agent.recurrence_type === 'schedule') {
            const dayMap = {
                sun: __('Sun', 'ai-bulk-post'),
                mon: __('Mon', 'ai-bulk-post'),
                tue: __('Tue', 'ai-bulk-post'),
                wed: __('Wed', 'ai-bulk-post'),
                thu: __('Thu', 'ai-bulk-post'),
                fri: __('Fri', 'ai-bulk-post'),
                sat: __('Sat', 'ai-bulk-post'),
            };
            const days = (agent.recurrence_days || [])
                .map((d) => dayMap[d] || d)
                .join(', ');
            const time = agent.recurrence_time || '09:00';
            return __('%s at %s', 'ai-bulk-post')
                .replace('%s', days)
                .replace('%s', time);
        }

        return __('Not scheduled', 'ai-bulk-post');
    };

    const formatLastRun = () => {
        if (!agent.last_run) return __('Never', 'ai-bulk-post');
        const date = new Date(agent.last_run + ' UTC');
        const now = new Date();
        const diffMs = now - date;
        const diffMin = Math.floor(diffMs / 60000);

        if (diffMin < 1) return __('Just now', 'ai-bulk-post');
        if (diffMin < 60) return __('%d min ago', 'ai-bulk-post').replace('%d', diffMin);

        const diffHours = Math.floor(diffMin / 60);
        if (diffHours < 24) {
            return __('%d hours ago', 'ai-bulk-post').replace('%d', diffHours);
        }

        const diffDays = Math.floor(diffHours / 24);
        return __('%d days ago', 'ai-bulk-post').replace('%d', diffDays);
    };

    return (
        <div className={`aibp-agent-card ${isActive ? 'aibp-agent-active' : 'aibp-agent-passive'}`}>
            <div className="aibp-agent-card-top">
                <div className="aibp-agent-card-header">
                    <span className="aibp-agent-status-badge" style={{ background: isActive ? '#00a32a' : '#dcdcde' }}>
                        {isActive ? __('Active', 'ai-bulk-post') : __('Paused', 'ai-bulk-post')}
                    </span>
                    <h3 className="aibp-agent-title">{agent.title}</h3>
                </div>

                <div className="aibp-agent-card-meta">
                    <span className="aibp-agent-badge" style={{ background: colors.bg, color: colors.text }}>
                        {agent.provider}
                    </span>
                    <span className="aibp-agent-model-tag">{agent.model}</span>
                </div>

                <div className="aibp-agent-card-details">
                    <div className="aibp-agent-detail">
                        <span className="aibp-agent-detail-icon">⏱</span>
                        <span>{formatRecurrence()}</span>
                    </div>
                    <div className="aibp-agent-detail">
                        <span className="aibp-agent-detail-icon">✎</span>
                        <span>
                            <strong>{agent.count}</strong> {__('posts generated', 'ai-bulk-post')}
                        </span>
                    </div>
                    <div className="aibp-agent-detail">
                        <span className="aibp-agent-detail-icon">◷</span>
                        <span>{__('Last run:', 'ai-bulk-post')} {formatLastRun()}</span>
                    </div>
                </div>
            </div>

            <div className="aibp-agent-card-actions">
                <div className="aibp-agent-actions-primary">
                    <button className="button button-small aibp-btn-primary" onClick={onEdit}>
                        {__('Edit', 'ai-bulk-post')}
                    </button>
                    <button className="button button-small" onClick={onRun}>
                        {__('Run Now', 'ai-bulk-post')}
                    </button>
                    <button
                        className={`button button-small ${isActive ? '' : 'aibp-btn-success-outline'}`}
                        onClick={onToggle}
                    >
                        {isActive
                            ? __('Pause', 'ai-bulk-post')
                            : __('Resume', 'ai-bulk-post')}
                    </button>
                </div>
                <div className="aibp-agent-actions-secondary">
                    <button className="button button-small button-link aibp-btn-icon" onClick={onDuplicate} title={__('Clone', 'ai-bulk-post')}>
                        ⧉
                    </button>
                    <button className="button button-small button-link aibp-btn-icon aibp-btn-danger-text" onClick={onDelete} title={__('Delete', 'ai-bulk-post')}>
                        ✕
                    </button>
                </div>
            </div>
        </div>
    );
}
